import {AddressSearcherComponent} from './address-searcher.component';
import {NgModule} from '@angular/core';
import {NguiAutoCompleteModule} from '@ngui/auto-complete';
/**
 * Created by Rumyantsev Daniil on 19.02.2018.
 */

@NgModule({
  imports: [
     NguiAutoCompleteModule,
  ],
  declarations: [
    AddressSearcherComponent,
  ],
  exports: [
    AddressSearcherComponent,
  ],
  providers: [
  ]
})
export class AddressSearcherModule {

}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/_commonComp/address-searcher/address-searcher.module.ts